import { Text, VStack } from 'ui_2';

export const SunRising = () => {
  return (
    <div className='absolute inset-0 z-40 flex w-full items-center justify-center'>
      <div className='absolute inset-0 h-[calc(100%)] bg-black/20' />
      <VStack className='relative w-4/5 max-w-[325px]  items-center gap-2 rounded-[30px] bg-gray-50 px-6 py-4 text-center'>
        <div className='h-[39px] w-[78px] rounded-t-full bg-squashYellow'></div>
        <Text font='bold-md'>The sun is rising on a new day</Text>
        <Text>
          We're updating the daily onchain data. The game will be back in action
          shortly!
        </Text>
      </VStack>
    </div>
  );
};
